var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.21875,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1862 14.3728L17.9733 19.9111M15.0269 19.9111L14.814 14.3728M20.948 12.3975C21.1585 12.4295 21.3677 12.4633 21.5769 12.4996M20.948 12.3975L20.2908 20.9406C20.264 21.2885 20.1068 21.6133 19.8508 21.8503C19.5948 22.0873 19.2588 22.2189 18.9099 22.2188H14.0903C13.7415 22.2189 13.4055 22.0873 13.1494 21.8503C12.8934 21.6133 12.7363 21.2885 12.7095 20.9406L12.0522 12.3975M20.948 12.3975C20.2378 12.2901 19.5239 12.2086 18.8078 12.1532M12.0522 12.3975C11.8418 12.4289 11.6326 12.4627 11.4233 12.499M12.0522 12.3975C12.7625 12.2901 13.4764 12.2086 14.1925 12.1532M18.8078 12.1532V11.5895C18.8078 10.8634 18.2478 10.2578 17.5216 10.2351C16.8408 10.2133 16.1594 10.2133 15.4786 10.2351C14.7525 10.2578 14.1925 10.864 14.1925 11.5895V12.1532M18.8078 12.1532C17.2716 12.0345 15.7286 12.0345 14.1925 12.1532",
    stroke: "#7D7D7D",
    strokeWidth: 0.923052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.734face1816de5f593acecd8d72b16da.svg";
export { ForwardRef as ReactComponent };